import React from "react";
import styled from "styled-components";
import {GAME_MODE_CONFIG} from "../../config";
import {Link} from "react-router-dom";

const MenuContainer = styled.nav`
  display: flex;
  margin-top: 1.5625em;
  width: 100%;
  align-items: flex-start;
  font-family: Manrope, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 1em;
  color: #fff;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1;
  justify-content: center;
`;

const MenuList = styled.ul`
  justify-content: end;
  align-items: start;
  align-content: flex-start;
  flex-wrap: wrap;
  align-self: stretch;
  display: flex;
  min-width: 15em;
  margin-top: auto;
  margin-bottom: auto;
  gap: 0.5em;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const MenuItem = styled.li`
  color: ${props => props.active ? '#F3D482' : '#FFF'};
  border-radius: 0.5em;
  white-space: nowrap;
  padding: 0.5em 0.75em;
  gap: 0.25em;
  background-color: ${props => props.active ? '#16191B' : 'transparent'};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #16191B;
    color: #F3D482;
  }
`;

const StyledLink = styled(Link)`
  color: unset;
  cursor: pointer;
  text-decoration: none;
`;

const GameModeMenu = ({ slug }) => {
  return (
    <MenuContainer role="navigation" aria-label="Game modes">
      <MenuList>
        {Object.keys(GAME_MODE_CONFIG).map((modeId) => (
          <StyledLink key={modeId} to={`/${GAME_MODE_CONFIG[modeId].slug}`}>
            <MenuItem active={slug === GAME_MODE_CONFIG[modeId].slug}>
              {GAME_MODE_CONFIG[modeId].shortName}
            </MenuItem>
          </StyledLink>
        ))}
      </MenuList>
    </MenuContainer>
  );
};

export default GameModeMenu;
